import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { GitBranch } from 'lucide-react';
import { Badge } from '@shadcn/components/ui/badge';
import { countConditions } from '../conditions/conditionUtils';

const ConditionNode = ({ data, selected }) => {
  const conditionCount = data.conditionGroup ? countConditions(data.conditionGroup) : 0;

  return (
    <div className={`px-4 py-3 rounded-lg border-2 bg-white shadow-md min-w-[200px] transition-shadow ${
      selected ? 'border-amber-600 shadow-lg ring-4 ring-amber-200' : 'border-amber-500'
    }`}>
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-amber-500 !w-3 !h-3 !border-2 !border-white"
      />
      <div className="flex items-center gap-2">
        <div className="p-1.5 rounded bg-amber-50">
          <GitBranch className="text-amber-500" size={16} />
        </div>
        <span className="font-medium text-sm text-amber-700">If...</span>
      </div>
      <div className="text-xs text-gray-600 mt-1.5 line-clamp-2 max-w-[180px]">
        {data.label || 'Set condition'}
      </div>
      {conditionCount > 1 && (
        <Badge variant="secondary" className="mt-1.5 text-[10px] py-0 px-1.5">
          {conditionCount} conditions
        </Badge>
      )}
      {/* Yes path - left */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="yes"
        className="!bg-green-500 !w-3 !h-3 !border-2 !border-white"
        style={{ left: '30%' }}
      />
      {/* No path - right */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="no"
        className="!bg-red-500 !w-3 !h-3 !border-2 !border-white"
        style={{ left: '70%' }}
      />
      <div className="flex justify-between mt-2 px-1">
        <span className="text-[10px] text-green-600 font-medium">Yes</span>
        <span className="text-[10px] text-red-600 font-medium">No</span>
      </div>
    </div>
  );
};

export default ConditionNode;
